import { CedeSDKError } from "./base";
import { SdkErrorCodes, SdkErrorMessages } from "./errorsMetadata";

/**
 * @description Default error coming from the cede server API
 */
export class ApiError extends CedeSDKError {
  constructor(code = SdkErrorCodes.API_ERROR, message = SdkErrorMessages.API_ERROR) {
    super(code, message);
    this.name = "ApiError";
  }
}
/**
 * @description Thrown when the API request failed
 */
export class InvalidApiRequestError extends ApiError {
  constructor(errorMessage: string) {
    super(SdkErrorCodes.INVALID_API_REQUEST, SdkErrorMessages.INVALID_API_REQUEST(errorMessage));
    this.name = "InvalidApiRequestError";
  }
}

/**
 * @description Thrown when the API request failed due to an internal error
 */
export class InternalApiExceptionError extends ApiError {
  constructor(errorMessage: string) {
    super(SdkErrorCodes.INTERNAL_API_EXCEPTION, errorMessage);
    this.name = "InternalApiExceptionError";
  }
}
